module.exports = __webpack_public_path__ + "static/stava_ipad_2-93d8510d96b1c5808a582418a8eed3d8.png";